import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .init({
    lng: "es",
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      // English
      en: {
        translation: {
          email: "E-mail",
          "Email": "Email",
          password: "Password",
          write_your_email: "Write your E-mail",
          write_your_password: "Write your password",
          login: "Login",
          user_login_bad_credentials: "The user information you provided does not exist or the credentials used are not correct.",
          go_home: "Go to home page",
          profile: "Profile",
          edit_profile: "Editar profile",
          exit: "Logout",
          menu: "Menu",
          administration: "Administration",
          specialities: "Specialities",
          modalities: "Modalities",
          clubs: "Clubs",
          teams: "Teams",
          team: "Team",
          seasons: "Seasons",
          "Name": "Name",
          changed_at: "Last updated",
          "Write to search": "Write to search",
          search: "Search",
          new_speciality: "New speciality",
          "Delete": "Delete",
          delete_speciality: "Delete speciality",
          delete_speciality_message: "Speciality <strong>{{speciality_name}} ({{speciality_code}})</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          "Save": "Save",
          "Close": "Close",
          "Expand": "Expand",
          "Collapse": "Collapse",
          "Value": "Value",
          "Average": "Average",
          "Maximum": "Maximum",
          "Minimum": "Minimum",
          actions: "actions",
          description: "Description",
          code: "Code",
          edit_speciality: "Edit speciality",
          icon_upload_message: "Optionally upload an image",
          single_image_warning: "Only un file of type image can be uploaded. Delete the current image to upload a different one.",
          new_modality: "New modality",
          speciality: "Speciality",
          gender: "Gender",
          select_gender: "- Select gender -",
          man: "Man",
          woman: "Woman",
          "Men": "Men",
          "Women": "Women",
          "Mixt": "Mixt",
          distance: "Distance",
          edit_modality: "Edit modality",
          "Delete modality": "Delete modality",
          delete_modality_message: "Modality <strong>{{speciality_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          new_club: "New club",
          edit_club: "Edit club",
          delete_club: "Delete club",
          document_id: "ID",
          date_foundation: "Foundation date",
          region: "Region",
          city: "City",
          website: "Website",
          address: "Address",
          phone: "Phone",
          registry_num: "Registry number",
          select_region: "- Select region -",
          logo: "Logo",
          delete_club_message: "Club <strong>{{club_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          new_season: "New season",
          "Start date": "Start date",
          "End date": "End date",
          edit_season: "Edit season",
          delete_season: "Delete season",
          delete_season_message: "Season <strong>{{season_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          categories: "Categories",
          new_category: "New category",
          edit_category: "Edit category",
          age_start: "Age start",
          age_end: "Age end",
          start_age_warning: "Set a valid age.",
          delete_category: "Delete category",
          delete_category_message: "Category <strong>{{category_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          new_team: "New team",
          club: "Club",
          select_club: "- Select club",
          modality: "Modality",
          select_modality: "- Select modality -",
          category: "Category",
          select_category: "- Select category -",
          edit_team: "Edit team",
          delete_team: "Delete team",
          delete_team_message: "Team <strong>{{team_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          management: "Management",
          users: "Users",
          new_user: "New user",
          first_name: "First name",
          last_name: "Last name",
          birthdate: "Birthdate",
          role: "Role",
          "Role": "Role",
          "Administrator": "Administrador",
          "Manager": "Manager",
          "Coach": "Coach",
          "Athlete": "Athlete",
          "Managers": "Managers",
          "Coaches": "Coaches",
          "Athletes": "Athletes",
          edit_user: "Edit user",
          delete_user: "Delete user",
          delete_user_message: "User <strong>{{user_name}} ({{user_email}})</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          my_space: "My space",
          athletes: "Athletes",
          reports: "Reports",
          coach: "Coach",
          training_templates: "Training templeates",
          training_sessions: "Training sessions",
          athlete: "Athlete",
          disable_user: "Disable user",
          disable_user_message: "User <strong>{{user_name}} ({{user_email}})</strong> will be disabled. That means that he/she will no longer be able to access the platform until enabled again. ¿Are you sure you want to diable him/her?",
          disable: "Disable",
          user_status_switch_label: "User is enabled?",
          disabled: "Disabled",
          new_athlete: "New athlete",
          birth_city: "City of birth",
          birth_region: "Region of birth",
          birth_country: "Country of birth",
          country: "Country",
          athlete_status_switch_label:  "¿Is athlete active?",
          birth_place: "Place of birth",
          residence_place: "Personal address",
          select_country: "- Select country -",
          avatar_upload_message: "Optionally upload a photo of the athlete",
          years: "Years",
          edit_athlete: "Edit athlete",
          team_athletes: "Team athletes",
          season: "Season",
          select_season: "- Select season -",
          select_athlete: "- Select athlete -",
          dorsal: "Dorsal",
          position: "Position",
          athlete_measurements: "Athlete measurements",
          measurement_date: "Measurement date",
          weight_label: "Weight (gr)",
          height_label: "Height (cm)",
          bmi_label: "IMC (kg/m²)",
          fm_label: "Fat (kg/m²)",
          bm_label: "Mass (kg/m²)",
          staff: "Staff",
          new_staff: "New staff member",
          edit_staff: "Edit staff member",
          staff_status_switch_label:  "Staff member is active?",
          team_staff: "Staff members",
          select_staff: "- Select staff -",
          "User": "User",
          notifications: "Notifications",
          wearables: "Wearables",
          select_team: "- Select team -",
          videos: "Videos",
          video_upload_message: "Upload video",
          video_mandatory_alert: "You must upload one video",
          edit_video: "Edit video",
          delete_video: "Delete video",
          delete_video_message: "The video <strong>{{video_name}}</strong> and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          training_session_tpls: "Training session templates",
          new_training_session_tpl: "New training session template",
          edit_training_session_tpl: "Edit training session template",
          new_training_session: "New training session",
          edit_training_session: "Edit training session",
          goals: "Goals",
          phases: "Exercise groups",
          delete_training_session_tpl: "Delete training session template",
          delete_training_session_tpl_message: "The training session template <strong>{{training_session_tpl_name}}</strong> and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          new_training_session_phase_tpl: "New group of exercises",
          delete_training_session: "Delete training session",
          delete_training_session_message: "The training session <strong>{{training_session_name}}</strong> and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          new_training_session_phase: "New group of exercises",
          recipients_training: "Athletes who will do it",
          new_phase: "New group of exercises",
          training_session_no_recipients: "There are no athletes assigned to this training session.",
          add_athletes: "Add athletes",
          select_option: "- Select an option -",
          add: "Add",
          reference_already_assigned: "This assignment already exists",
          no_exercises_in_phase: "No exercises have been defined for this group",
          edit_training_session_phase_tpl: "Edit exercise group",
          delete_training_session_phase_tpl: "Delete exercise group",
          delete_training_session_phase_tpl_message: "The <strong>{{training_session_tpl_phase_name}}</strong> exercise group and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          edit_training_session_phase: "Edit exercise group",
          delete_training_session_phase: "Delete exercise group",
          delete_training_session_phase_message: "The <strong>{{training_session_phase_name}}</strong> exercise group and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          add_exercise: "Add exercise",
          new_training_session_exercise_tpl: "New exercise",
          delete_training_session_exercise_tpl: "Eliminar ejercicio",
          delete_training_session_exercise_tpl_message: "The <strong>{{training_session_tpl_exercise_name}}</strong> exercise and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          edit_training_session_exercise_tpl: "Edit exercise",
          new_training_session_exercise: "New exercise",
          delete_training_session_exercise: "Delete exercise",
          delete_training_session_exercise_message: "The <strong>{{training_session_exercise_name}}</strong> exercise and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          edit_training_session_exercise: "Edit exercise",
          no_videos_in_phase: "No videos have been associated with this group.",
          add_videos: "Añadir videos",
          video_selector: "Video selector",
          no_videos_in_excercise: "No se han asociado videos a este ejercicio",
          clone: "Clone",
          exercises: "Exercises",
          no_phases_message: "No defined exercise group",
          one_phase: "1 group of exercises",
          multiple_phases: "exercise groups",
          no_exercises_message: "No defined exercise",
          one_exercise: "1 exercise",
          multiple_exercises: "exercises",
          zero_exercises: "0 exercises",
          date_part: "Date",
          time_part: "Time",
          date_time: "Date and time",
          message_template_source: "How do you want to start designing your training session?",
          from_scratch: "From scratch",
          from_template: "Using a template",
          select_template: "- Select template -",
          no_date_planned: "Unplanned activity",
          trainings: "Trainings",
          competitions: "Competitions",
          new_competition: "New competition",
          date_description: "Description of the date",
          venue_name: "Name of the venue",
          venue_link: "Link to the venue",
          documents_upload_message: "You can optionally upload documents",
          delete_competition: "Delete competition",
          delete_competition_message: "The <strong>{{competition_name}}</strong> competition and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          edit_competition: "Edit competition",
          passed_competitions: "Past competitions",
          upcoming_events: "Upcoming events",
          connection_expired: "Session expired. Authenticate again to access.",
          welcome: "Welcome",
          forgot_password_question: "Forgot your password?",
          reset_password: "Reset password",
          rankings: "Rankings",
          color: "Color",
          management_2: "Manage",
          birth: "Birth",
          contact_info: "Contact info",
          weight: "Weight",
          "Body Mass Index": "Body Mass Index",
          "Body Mass": "Body Mass",
          "Fat mass": "Fat mass",
          "Athletes ranking": "Athletes ranking",
          "Teams ranking": "Teams ranking",
          "Statistics": "Statistics",
          "Athletes statistics": "Athletes statistics",
          "Teams statistics": "Teams statistics",
          "Performance": "Performance",
          delete_ats_message: "The athlete assignment to the team and season will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          "Yes": "Yes",
          "No": "No",
          athlete_team_seasons: "Seasons and teams",
          delete_sts_message: "The coach assignment to the team and season will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          staff_team_seasons: "Seasons and teams",
          new_video: "New video",
          "Check your credentials or ask your superior. Yo are not allowed to login now.": "Check your credentials or ask your superior. Yo are not allowed to login now.",
          "Athletes and teams": "Athletes and teams",
          "Edit coach": "Edita coach",
          "Delete coach": "Delete coach",
          "delete_coach_message": "Coach <strong>{{coach_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          "Competitions and events": "Competitions and events",
          "Events": "Events",
          "Passed events": "Eventos pasados",
          "New event": "New event",
          "delete_event_message": "Event <strong>{{event_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          "Athlete rankings": "Athlete rankings",
          "ranking_date": "Ranking date",
          "points_label": "Points",
          "Man": "Man",
          "Woman": "Woman",
          "delete_athlete": "Delete athlete",
          "delete_athlete_message": "Athlete <strong>{{athlete_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          "sex": "Sex",
          "select_sex": "- Select sex -",
          "Check your inbox to read the reset password instructions email.": "Check your inbox to read the reset password instructions email.",
          "Send a link to reset password": "Send a link to reset password",
          "Reset": "Reset",
          "Back to login": "Back to login",
          "Reset your password": "Reset your password",
          "Repeat password": "Repeat password",
          "Password changed. Continue to login.": "Password changed. Continue to login.",
          "The passwords entered do not match.": "The passwords entered do not match.",
          "Password must be at least 8 characters long.": "Password must be at least 8 characters long.",
          athlete_performances: "Athlete performance",
          performance_date: "Performace date",
          "No performance data available": "No performance data available",
          "Select KPI": "Select KPI",
          "New version available!": "New version available!",
          "A new version ({{version}}) of the application is available.": "A new version ({{version}}) of the application is available.",
          "Please reload to get the latest features and improvements.": "Please reload to get the latest features and improvements.",
          "Later": "Later",
          "Reload now": "Reload now",
          perf1_label: "Performance KPI 1",
          perf2_label: "Performance KPI 2",
          perf3_label: "Performance KPI 3",
          perf4_label: "Performance KPI 4",
          "Settings": "Settings",
          "KPI Labels": "KPI Labels",
          "KPI Labels Configuration": "KPI Labels Configuration",
          "Configure the labels for the 4 performance KPIs used throughout the application": "Configure the labels for the 4 performance KPIs used throughout the application",
          "KPI 1 Label": "KPI 1 Label",
          "KPI 2 Label": "KPI 2 Label",
          "KPI 3 Label": "KPI 3 Label",
          "KPI 4 Label": "KPI 4 Label",
          "e.g., Maximum Speed": "e.g., Maximum Speed",
          "e.g., Endurance": "e.g., Endurance",
          "e.g., Strength": "e.g., Strength",
          "e.g., Agility": "e.g., Agility",
          "Save Settings": "Save Settings",
          "Saving...": "Saving...",
          "Settings saved successfully": "Settings saved successfully",
          "Error saving settings": "Error saving settings",
          "New program": "New program",
          "Edit program": "Edit program",
          "Delete program": "Delete program",
          delete_program_message: "Program <strong>{{program_name}}</strong> and all related data will be deleted. This action cannot be undone. Do you really want to delete it permanently?",
          "Programs": "Programs",
          "Program members": "Program members",
          "Member since": "Member since",
          "Program documents": "Program documents",
          "Only one document can be uploaded. Delete the current document to upload a different one.": "Only one document can be uploaded. Delete the current document to upload a different one.",
          "New media": "New media",
          "Upload video, file or document": "Upload video, file or document",
          "You must upload one video, image or document": "You must upload one media",
          "Type": "Type",
          "Edit media": "Edit media",
          "Delete media": "Delete media",
          delete_program_media_message: "The media <strong>{{program_media_name}}</strong> and all data dependent on it will be deleted. This action cannot be undone. Are you sure you want to permanently delete it?",
          "Documents of": "Documents of",
          "Download": "Download",
          "This media has no coments.": "This media has no coments.",
          "Comments": "Comments",
          "Add comment": "Add comment",
          "Comment": "Comment",
          "Author": "Author",
          "There are no new notifications for you.": "There are no new notifications for you.",
          "Documents": "Documents",
          "User cannot be deleted. Try again later.": "User cannot be deleted. Try again later.",
          "Category cannot be deleted. There are teams in this category.": "Category cannot be deleted. There are teams in this category.",
          "Rows per page:": "Rows per page:",
          "of": "of",
          "Modality cannot be deleted. There are teams of this modality.": "Modality cannot be deleted. There are teams of this modality.",
          "Season cannot be deleted. There is data related.": "Season cannot be deleted. There is data related.",
          "Club cannot be deleted. There is data related.": "Club cannot be deleted. There is data related.",
          "Team cannot be deleted. There is data related.": "Team cannot be deleted. There is data related.",
          "Athlete cannot be deleted. There is data related.": "Athlete cannot be deleted. There is data related.",
          "Athlete team season cannot be deleted. There is data related.": "Athlete team season cannot be deleted. There is data related.",
          "Competition cannot be deleted. Try again later.": "Competition cannot be deleted. Try again later.",
          "Event cannot be deleted. Try again later.": "Event cannot be deleted. Try again later.",
          "Video cannot be deleted. Try again later.": "Video cannot be deleted. Try again later.",
          "Load more": "Load more",
          "loading": "Loading",
          "There are no upcomming events.": "There are no upcomming events.",
          "Measurement cannot be deleted. Try again later.": "Measurement cannot be deleted. Try again later.",
          "Staff cannot be deleted. There is data related.": "Staff cannot be deleted. There is data related.",
          "Mark as read": "Mark as read",
          "Members": "Members",
          "Athlete trainings": "Athlete trainings",
          "New folder": "New folder",
          "New subfolder": "New subfolder",
          "Edit folder": "Edit folder",
          "Delete folder": "Delete folder",
          "Are you sure you want to delete this folder?": "Are you sure you want to delete this folder?",
          "Are you sure you want to delete this member?": "Are you sure you want to delete this member?",
          "Are you sure you want to delete {count} members?": "Are you sure you want to delete {count} members?",
          "Please select at least one member to delete": "Please select at least one member to delete",
          "Delete selected": "Delete selected",
          "Error deleting members": "Error deleting members",
          "This action cannot be undone.": "This action cannot be undone.",
          "Cancel": "Cancel",
          "Error deleting folder. Make sure it doesn't contain subfolders or files.": "Error deleting folder. Make sure it doesn't contain subfolders or files.",
          "Root": "Root",
          "All files": "All files",
          "No folders yet": "No folders yet",
          "No folders": "No folders",
          "This folder is empty": "This folder is empty",
          "Right-click here to create a new folder": "Right-click here to create a new folder",
          "or use the yellow button at the bottom right": "or use the yellow button at the bottom right",
          "Error moving folder": "Error moving folder",
          "Error reordering folders": "Error reordering folders",
          "No files in this folder": "No files in this folder",
          "Error moving file": "Error moving file",
          "Drop files here to upload": "Drop files here to upload",
          "Uploading files...": "Uploading files...",
          "Error creating media": "Error creating media",
          "Error uploading files": "Error uploading files",
          "Error uploading file": "Error uploading file",
          "File cannot be uploaded.": "File cannot be uploaded.",
          "Image too large": "Image too large",
          "Maximum size for images is 5MB": "Maximum size for images is 5MB",
          "Some files were not uploaded": "Some files were not uploaded",
          "No results found": "No results found",
          "Search...": "Search...",
          "Are you sure you want to delete the folder": "Are you sure you want to delete the folder",
          "This folder contains": "This folder contains",
          "and": "and",
          "more items": "more items",
          "All folders and files will be permanently deleted. This action cannot be undone.": "All folders and files will be permanently deleted. This action cannot be undone.",
          "Delete permanently": "Delete permanently",
          "Drag files here to upload them to": "Drag files here to upload them to",
          "this folder": "this folder",
          "A-Z": "A-Z",
          "By date": "By date",
          "Ascending": "Ascending",
          "Descending": "Descending",
          "Planning": "Planning",
          "Selection mode": "Selection mode",
          "Exit selection mode": "Exit selection mode",
          "days selected": "days selected",
          "Add to selected days": "Add to selected days",
          "Clear selection": "Clear selection",
          "Add training to multiple days": "Add training to multiple days",
          "You are adding training to": "You are adding training to",
          "Entries created successfully for all selected days": "Entries created successfully for all selected days",
          "Some entries could not be created": "Some entries could not be created",
          "Error creating entries": "Error creating entries",
          "Add to all selected days": "Add to all selected days",
          "Template": "Template",
          "Training cannot be deleted. Try again later.": "Training cannot be deleted. Try again later.",
          "Session": "Session",
          "Delete from selected days": "Delete from selected days",
          "Are you sure you want to delete all training entries from the selected days?": "Are you sure you want to delete all training entries from the selected days?",
          "Entries deleted successfully": "Entries deleted successfully",
          "Some entries could not be deleted": "Some entries could not be deleted",
          "Error deleting entries": "Error deleting entries",
          "entries": "entries",
          "days": "days",
          "selected days": "selected days",
          "- All clubs -": "- All clubs -",
          "- All users -": "- All users -",
          "Member type": "Member type",
          "All types": "All types",
          "Filters": "Filters",
          "Select members": "Select members",
          "Please select at least one member": "Please select at least one member",
          "Error adding members": "Error adding members",
          "All teams": "All teams",
          "Clubs": "Clubs",
          "Teams": "Teams",
          "Users": "Users",
          "members": "members",
          "Search by name or email": "Search by name or email",
          "Select all": "Select all",
          "No members found": "No members found",
          "Add members": "Add members",
          "Current members": "Current members",
          "Share": "Share",
          "Team": "Team",
          "Club": "Club",
          "All clubs": "All clubs"
        }
      },
      // Spanish
      es: {
        translation: {
          email: "Correo electrónico",
          "Email": "Correo electrónico",
          password: "Contraseña",
          write_your_email: "Escribe tu correo electróncio",
          write_your_password: "Escribe tu contraseña",
          login: "Iniciar sesión",
          user_login_bad_credentials: "El usuario no existe o las credenciales de acceso no son válidas.",
          go_home: "Ir a la página de inicio",
          profile: "Perfil",
          edit_profile: "Editar perfil",
          exit: "Salir",
          menu: "Menú",
          administration: "Administración",
          specialities: "Especialidades",
          modalities: "Modalidades",
          clubs: "Clubes",
          teams: "Equipos",
          team: "Equipo",
          seasons: "Temporadas",
          "Name": "Nombre",
          changed_at: "Última modificación",
          "Write to search": "Escribe lo que quieres buscar",
          search: "Buscar",
          new_speciality: "Nueva especialidad",
          "Delete": "Eliminar",
          delete_speciality: "ELiminar especialidad",
          delete_speciality_message: "La especialidad <strong>{{speciality_name}} ({{speciality_code}})</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          "Save": "Guardar",
          "Close": "Cerrar",
          "Expand": "Expandir",
          "Collapse": "Colapsar",
          "Value": "Valor",
          "Average": "Promedio",
          "Maximum": "Máximo",
          "Minimum": "Mínimo",
          actions: "Acciones",
          description: "Descripción",
          code: "Código",
          edit_speciality: "Editar especialidad",
          icon_upload_message: "Opcionalmente puedes cargar una imagen",
          single_image_warning: "Sólo se permiten cargar un archivos de tipo imagen. Elimina el archivo cargado para cargar uno diferente.",
          new_modality: "Nueva modalidad",
          speciality: "Especialidad",
          select_speciality: "- Seleccionar especialidad -",
          gender: "Sexo",
          select_gender: "- Seleccionar sexo -",
          man: "Hombre",
          woman: "Mujer",
          "Men": "Hombres",
          "Women": "Mujeres",
          "Mixt": "Mixto",
          distance: "Distancia",
          edit_modality: "Editar modalidad",
          "Delete modality": "Eliminar modalidad",
          delete_modality_message: "La modalidad <strong>{{modality_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          new_club: "Nuevo club",
          edit_club: "Editar club",
          delete_club: "Eliminar club",
          document_id: "NIF",
          date_foundation: "Fecha de fundación",
          region: "Provincia",
          city: "Municipio",
          website: "Página web",
          address: "Dirección postal",
          phone: "Teléfono",
          registry_num: "Número de registro",
          select_region: "- Selecciona una provincia -",
          logo: "Logotipo",
          delete_club_message: "El club <strong>{{club_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          new_season: "Nueva temporada",
          "Start date": "Fecha de inicio",
          "End date": "Fecha de fin",
          edit_season: "Editar temporada",
          delete_season: "Elininar temporada",
          delete_season_message: "La temporada <strong>{{season_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          categories: "Categorías",
          new_category: "Nueva categoría",
          edit_category: "Editar categoría",
          age_start: "Edad mínima",
          age_end: "Edad máxima",
          start_age_warning: "Indicar una edad válida.",
          delete_category: "Elininar categoría",
          delete_category_message: "La categoría <strong>{{category_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          new_team: "Nuevo equipo",
          club: "Club",
          select_club: "- Selecciona un club",
          modality: "Modalidad",
          select_modality: "- Selecciona una modalidad -",
          category: "Categoría",
          select_category: "- Selecciona una categoría -",
          edit_team: "Editar equipo",
          delete_team: "Eliminar equipo",
          delete_team_message: "El equipo <strong>{{team_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          management: "Dirección",
          users: "Usuarios",
          new_user: "Nuevo usuario",
          first_name: "Nombre",
          last_name: "Apellidos",
          birthdate: "Fecha de nacimiento",
          role: "Rol",
          "Role": "Rol",
          select_role: "- Seleccionar rol -",
          "Administrator": "Administrador",
          "Manager": "Directivo",
          "Coach": "Entrenador",
          "Athlete": "Deportista",
          "Managers": "Directivos",
          "Coaches": "Entrenadores",
          "Athletes": "Deportistas",
          edit_user: "Editar usuario",
          delete_user: "Eliminar usuario",
          delete_user_message: "El usuario <strong>{{user_name}} ({{user_email}})</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          my_space: "Mi espacio",
          athletes: "Deportistas",
          reports: "Informes",
          coach: "Entrenador",
          training_templates: "Plantillas de entreno",
          training_sessions: "Sesiones de entreno",
          athlete: "Deportista",
          disable_user: "Desactivar usuario",
          disable_user_message: "El usuario <strong>{{user_name}} ({{user_email}})</strong> será desactivado. Esto significa que ya no podrá acceder a la plataforma hasta que vuelva a ser activado. ¿Estás seguro de que quieres desactivarlo?",
          disable: "Desactivar",
          user_status_switch_label: "¿El usuario está activado?",
          disabled: "No activado",
          new_athlete: "Nuevo deportista",
          birth_city: "Ciudad de nacimiento",
          birth_region: "Provincia de nacimiento",
          birth_country: "País de nacimiento",
          country: "País",
          athlete_status_switch_label:  "¿El deportista está activado?",
          birth_place: "Lugar de nacimiento",
          residence_place: "Lugar de residencia",
          select_country: "- Seleccionar país -",
          avatar_upload_message: "Opcionalmente cargar foto del deportista",
          years: "Años",
          edit_athlete: "Editar deportista",
          team_athletes: "Deportistas del equipo",
          season: "Temporada",
          select_season: "- Seleccionar temporada -",
          select_athlete: "- Seleccionar deportista -",
          dorsal: "Dorsal",
          position: "Posición",
          athlete_measurements: "Mediciones del deportista",
          measurement_date: "Fecha de medición",
          weight_label: "Peso (gr)",
          height_label: "Altura (cm)",
          bmi_label: "IMC (kg/m²)",
          fm_label: "Grasa (kg/m²)",
          bm_label: "Masa (kg/m²)",
          staff: "Personal",
          new_staff: "Nuevo miembro de la plantilla",
          edit_staff: "Editar miembro de la plantilla",
          staff_status_switch_label:  "¿El miembro de la plantilla está activado?",
          team_staff: "Miembros de la plantilla",
          select_staff: "- Seleccionar personal -",
          "User": "Usuario",
          notifications: "Notificaciones",
          wearables: "Wearables",
          select_team: "- Seleccionar equipo -",
          videos: "Videos",
          video_upload_message: "Carga un video",
          video_mandatory_alert: "Es necesario cargar un vídeo",
          edit_video: "Editar video",
          delete_video: "Eliminar video",
          delete_video_message: "El video <strong>{{video_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          training_session_tpls: "Plantillas de sesiones de entreno",
          new_training_session_tpl: "Nueva plantilla de sesión de entreno",
          edit_training_session_tpl: "Editar plantilla de sesión de entreno",
          new_training_session: "Nueva sesión de entreno",
          edit_training_session: "Editar sesión de entreno",
          goals: "Objetivos",
          phases: "Grupos de ejercicios",
          delete_training_session_tpl: "Eliminar plantilla de sesión de entreno",
          delete_training_session_tpl_message: "La plantilla de sesión de entreno <strong>{{training_session_tpl_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          new_training_session_phase_tpl: "Nuevo grupo de ejercicios",
          delete_training_session: "Eliminar sesión de entreno",
          delete_training_session_message: "La sesión de entreno <strong>{{training_session_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          new_training_session_phase: "Nueva grupo de ejercicios",
          recipients_training: "Athletas que lo realizarán",
          new_phase: "Nuevo grupo de ejercicios",
          training_session_no_recipients: "No hay deportistas asignados a esta sesión de entreno",
          add_athletes: "Añadir deportistas",
          select_option: "- Selecciona una opción -",
          add: "Añadir",
          reference_already_assigned: "Esta asignación ya existe",
          no_exercises_in_phase: "No se han definido ejercicios para este grupo",
          edit_training_session_phase_tpl: "Editar grupo de ejercicios",
          delete_training_session_phase_tpl: "Eliminar grupo de ejercicios",
          delete_training_session_phase_tpl_message: "El grupo de ejercicios <strong>{{training_session_tpl_phase_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          edit_training_session_phase: "Editar grupo de ejercicios",
          delete_training_session_phase: "Eliminar grupo de ejercicios",
          delete_training_session_phase_message: "El grupo de ejercicios <strong>{{training_session_phase_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          add_exercise: "Añadir ejercicio",
          new_training_session_exercise_tpl: "Nuevo ejercicio",
          delete_training_session_exercise_tpl: "Eliminar ejercicio",
          delete_training_session_exercise_tpl_message: "El ejercicio <strong>{{training_session_tpl_exercise_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          edit_training_session_exercise_tpl: "Editar ejercicio",
          new_training_session_exercise: "Nuevo ejercicio",
          delete_training_session_exercise: "Eliminar ejercicio",
          delete_training_session_exercise_message: "El ejercicio <strong>{{training_session_exercise_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          edit_training_session_exercise: "Editar ejercicio",
          no_videos_in_phase: "No se han asociado videos a este grupo",
          add_videos: "Añadir videos",
          video_selector: "Selector de videos",
          no_videos_in_excercise: "No se han asociado videos a este ejercicio",
          clone: "Duplicar",
          exercises: "Ejercicios",
          no_phases_message: "Ningún grupo de ejercicios definido",
          one_phase: "1 grupo de ejercicios",
          multiple_phases: "grupos de ejercicios",
          no_exercises_message: "Ningún ejercicio definido",
          one_exercise: "1 ejercicio",
          multiple_exercises: "ejercicios",
          zero_exercises: "0 ejercicios",
          date_part: "Fecha",
          time_part: "Hora",
          date_time: "Fecha y hora",
          message_template_source: "¿Cómo quieres empezar a diseñar la sesión de entrenamiento?",
          from_scratch: "Desde cero",
          from_template: "Usando una plantilla",
          select_template: "- Seleccionar plantilla -",
          no_date_planned: "Actividad no planificada",
          trainings: "Entrenamientos",
          competitions: "Competiciones",
          new_competition: "Nueva competición",
          date_description: "Descripción de la fecha",
          venue_name: "Nombre de la sede",
          venue_link: "Enlace a la sede",
          documents_upload_message: "Opcionalmente puees subir documentos",
          delete_competition: "Eliminar competición",
          delete_competition_message: "La competición <strong>{{competition_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          edit_competition: "Editar competición",
          passed_competitions: "Competiciones pasadas",
          upcoming_events: "Próximos eventos",
          connection_expired: "La conexión ha caducado. Vuelve a autenticarte en la aplicación",
          welcome: "Bienvenido/a",
          forgot_password_question: "¿Has olvidado la contraseña?",
          reset_password: "Restablecer contraseña",
          rankings: "Rankings",
          color: "Color",
          management_2: "Gestión",
          birth: "Nacimiento",
          contact_info: "Datos de contacto",
          weight: "Peso",
          "Body Mass Index": "Índice de masa corporal",
          "Body Mass": "Masa corporal",
          "Fat mass": "Masa grasa",
          "Athletes ranking": "Ranking de deportistas",
          "Teams ranking": "Ranking de equipos",
          "Statistics": "Estadísticas",
          "Athletes statistics": "Estadísticas de deportistas",
          "Teams statistics": "Estadísticas de equipos",
          "Performance": "Rendimiento",
          delete_ats_message: "El deportista asignado a esta temporada y equipo se eliminará. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          "Yes": "Sí",
          "No": "No",
          athlete_team_seasons: "Temporadas y equipos",
          delete_sts_message: "El entrenador asignado a esta temporada y equipo se eliminará. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          staff_team_seasons: "Temporadas y equipos",
          new_video: "Nuevo video",
          "Check your credentials or ask your superior. Yo are not allowed to login now.": "Revisa tus datos de acceso o pregunta a tu responsable o persona de contacto para la aplicación. No tienes permisos para acceder a la aplicación en estos momentos.",
          "Athletes and teams": "Deportistas y equipos",
          "New coach": "Nuevo entrenador",
          "Edit coach": "Editar entrenador",
          "Delete coach": "Eliminar entrenador",
          "delete_coach_message": "El entrenador <strong>{{coach_name}}</strong> y todos los datos que dependen de este, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          "Competitions and events": "Competiciones y eventos",
          "Events": "Eventos",
          "Passed events": "Eventos pasados",
          "New event": "Nuevo evento",
          "Edit event": "Editar evento",
          "Delete event": "Eliminar evento",
          "delete_event_message": "La competición <strong>{{event_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          "Athlete rankings": "Ranking del deportista",
          "ranking_date": "Fecha del ranking",
          "points_label": "Puntos",
          "Man": "Hombre",
          "Woman": "Mujer",
          "delete_athlete": "Eliminar deportista",
          "delete_athlete_message": "El deportista <strong>{{athlete_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          "sex": "Sexo",
          "select_sex": "- Seleccionar sexo -",
          "Check your inbox to read the reset password instructions email.": "Revisa tu bandeja de entrada y lee el correo con las instrucciones para restablecer la contraseña.",
          "Send a link to reset password": "Enviar enlace para restablecer contraseña",
          "Reset": "Restablecer",
          "Back to login": "Volver al inicio de sesión",
          "Reset your password": "Restablecer contraseña",
          "Repeat password": "Repetir contraseña",
          "Password changed. Continue to login.": "La contraseña ha sido modificada. Continua con el inicio de sesión.",
          "The passwords entered do not match.": "Las contraseñas introducidas no coinciden.",
          "Password must be at least 8 characters long.": "La contraseña debe tener un mímimo de 8 carateres.",
          athlete_performances: "Rendimiento del deportista",
          performance_date: "Fecha de medición",
          "No performance data available": "No hay datos de rendimiento disponibles",
          "Select KPI": "Seleccionar KPI",
          "New version available!": "¡Nueva versión disponible!",
          "A new version ({{version}}) of the application is available.": "Hay una nueva versión ({{version}}) de la aplicación disponible.",
          "Please reload to get the latest features and improvements.": "Por favor, recarga la página para obtener las últimas funciones y mejoras.",
          "Later": "Más tarde",
          "Reload now": "Recargar ahora",
          perf1_label: "Rendimiento KPI 1",
          perf2_label: "Rendimiento KPI 2",
          perf3_label: "Rendimiento KPI 3",
          perf4_label: "Rendimiento KPI 4",
          "Settings": "Configuración",
          "KPI Labels": "Etiquetas de KPIs",
          "KPI Labels Configuration": "Configuración de Etiquetas de KPIs",
          "Configure the labels for the 4 performance KPIs used throughout the application": "Configura las etiquetas para los 4 KPIs de rendimiento utilizados en toda la aplicación",
          "KPI 1 Label": "Etiqueta KPI 1",
          "KPI 2 Label": "Etiqueta KPI 2",
          "KPI 3 Label": "Etiqueta KPI 3",
          "KPI 4 Label": "Etiqueta KPI 4",
          "e.g., Maximum Speed": "ej., Velocidad máxima",
          "e.g., Endurance": "ej., Resistencia",
          "e.g., Strength": "ej., Fuerza",
          "e.g., Agility": "ej., Agilidad",
          "Save Settings": "Guardar configuración",
          "Saving...": "Guardando...",
          "Settings saved successfully": "Configuración guardada correctamente",
          "Error saving settings": "Error al guardar la configuración",
          "New program": "Nuevo programa",
          "Edit program": "Editar programa",
          "Delete program": "Eliminar programa",
          delete_program_message: "El programa <strong>{{program_name}}</strong> y todos los datos que dependen de este, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarlo de forma permanente?",
          "Programs": "Programas",
          "Program members": "Miembros del programa",
          "Member since": "Miembro desde",
          "Program documents": "Documentos del programa",
          "Only one document can be uploaded. Delete the current document to upload a different one.": "Sólo se permite cargar un documento. Elimina el documento cargado para cargar uno diferente.",
          "New media": "Nuevo media",
          "Upload video, file or document": "Carga un video, imagen o documento",
          "You must upload one video, image or document": "Tienes que cargar un vídeo, una imagen o un documento.",
          "Type": "Tipo",
          "Edit media": "Editar media",
          "Delete media": "Eliminar media",
          delete_program_media_message: "El media <strong>{{program_media_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
          "Documents of": "Documentos de",
          "Download": "Descargar",
          "This media has no coments.": "Este media todavía no tiene comentarios.",
          "Comments": "Comentarios",
          "Add comment": "Añadir comentario",
          "Comment": "Comentario",
          "Author": "Autor",
          "There are no new notifications for you.": "No hay notificaciones nuevas para ti.",
          "Documents": "Documentos",
          "User cannot be deleted. Try again later.": "El usuario no puede ser eliminado. Inténtalo de nuevo más tarde.",
          "Category cannot be deleted. There are teams in this category.": "La categoría no se puede eliminar. Existen equipos en esta categoría.",
          "Rows per page:": "Filas por página",
          "of": "de",
          "Modality cannot be deleted. There are teams of this modality.": "La modalidad no se puede eliminar. Existen equipos de esta modalidad.",
          "Season cannot be deleted. There is data related.": "La temporada no se puede elminar. Existen datos relacionados.",
          "Club cannot be deleted. There is data related.": "El club no se puede elminar. Existen datos relacionados.",
          "Team cannot be deleted. There is data related.": "El equipo no se puede elminar. Existen datos relacionados.",
          "Athlete cannot be deleted. There is data related.": "El deportista no se puede elminar. Existen datos relacionados.",
          "Athlete team season cannot be deleted. There is data related.": "La asociación del deportista a la temporada no se puede elminar. Existen datos relacionados.",
          "Competition cannot be deleted. Try again later.": "La competición no se puede eliminar. Inténtalo de nuev más tarde.",
          "Event cannot be deleted. Try again later.": "El evento no se puede eliminar. Inténtalo de nuev más tarde.",
          "Video cannot be deleted. Try again later.": "El video no se puede eliminar. Inténtalo de nuev más tarde.",
          "Load more": "Cargar más",
          "loading": "Cargando",
          "There are no upcomming events.": "No hay próximos eventos",
          "Measurement cannot be deleted. Try again later.": "Las mediciones no pueden ser eliminadas. Inténtalo de nuevo más tarde.",
          "Staff cannot be deleted. There is data related.": "El entrenador no puede ser eliminado. Tiene datos relacionados.",
          "Mark as read": "Marcar como leída",
          "Members": "Miembros",
          "Athlete trainings": "Entrenos del deportista",
          "New folder": "Nueva carpeta",
          "New subfolder": "Nueva subcarpeta",
          "Edit folder": "Editar carpeta",
          "Delete folder": "Eliminar carpeta",
          "Are you sure you want to delete this folder?": "¿Estás seguro de que quieres eliminar esta carpeta?",
          "Are you sure you want to delete this member?": "¿Estás seguro de que quieres eliminar este miembro?",
          "Are you sure you want to delete {count} members?": "¿Estás seguro de que quieres eliminar {count} miembros?",
          "Please select at least one member to delete": "Por favor selecciona al menos un miembro para eliminar",
          "Delete selected": "Eliminar seleccionados",
          "Error deleting members": "Error al eliminar miembros",
          "This action cannot be undone.": "Esta acción no se puede deshacer.",
          "Cancel": "Cancelar",
          "Error deleting folder. Make sure it doesn't contain subfolders or files.": "Error al eliminar la carpeta. Asegúrate de que no contiene subcarpetas ni archivos.",
          "Root": "Raíz",
          "All files": "Todos los archivos",
          "No folders yet": "Todavía no hay carpetas",
          "No folders": "No hay carpetas",
          "This folder is empty": "Esta carpeta está vacía",
          "Right-click here to create a new folder": "Haz clic derecho aquí para crear una nueva carpeta",
          "or use the yellow button at the bottom right": "o usa el botón amarillo de la parte inferior derecha",
          "Error moving folder": "Error al mover la carpeta",
          "Error reordering folders": "Error al reordenar las carpetas",
          "No files in this folder": "No hay archivos en esta carpeta",
          "Error moving file": "Error al mover el archivo",
          "Drop files here to upload": "Suelta los archivos aquí para subirlos",
          "Uploading files...": "Subiendo archivos...",
          "Error creating media": "Error al crear el media",
          "Error uploading files": "Error al subir los archivos",
          "Error uploading file": "Error al subir el archivo",
          "File cannot be uploaded.": "El archivo no se puede subir.",
          "Image too large": "Imagen demasiado grande",
          "Maximum size for images is 5MB": "El tamaño máximo para imágenes es de 5MB",
          "Some files were not uploaded": "Algunos archivos no se subieron",
          "No results found": "No se encontraron resultados",
          "Search...": "Buscar...",
          "Are you sure you want to delete the folder": "¿Estás seguro de que quieres eliminar la carpeta",
          "This folder contains": "Esta carpeta contiene",
          "and": "y",
          "more items": "elementos más",
          "All folders and files will be permanently deleted. This action cannot be undone.": "Todas las carpetas y archivos se eliminarán permanentemente. Esta acción no se puede deshacer.",
          "Delete permanently": "Eliminar permanentemente",
          "Drag files here to upload them to": "Arrastra archivos aquí para subirlos a",
          "this folder": "esta carpeta",
          "A-Z": "A-Z",
          "By date": "Por fecha",
          "Ascending": "Ascendente",
          "Descending": "Descendente",
          "Planning": "Planificación",
          "Selection mode": "Modo selección",
          "Exit selection mode": "Salir del modo selección",
          "days selected": "días seleccionados",
          "Add to selected days": "Añadir a los días seleccionados",
          "Clear selection": "Limpiar selección",
          "Add training to multiple days": "Añadir entreno a múltiples días",
          "You are adding training to": "Vas a añadir entreno a",
          "Entries created successfully for all selected days": "Entradas creadas correctamente para todos los días seleccionados",
          "Some entries could not be created": "Algunas entradas no pudieron ser creadas",
          "Error creating entries": "Error al crear las entradas",
          "Add to all selected days": "Añadir a todos los días seleccionados",
          "Template": "Plantilla",
          "Training cannot be deleted. Try again later.": "El entreno no se puede eliminar. Inténtalo de nuevo más tarde.",
          "Session": "Sesión",
          "Delete from selected days": "Eliminar de los días seleccionados",
          "Are you sure you want to delete all training entries from the selected days?": "¿Estás seguro de que quieres eliminar todas las entradas de entreno de los días seleccionados?",
          "Entries deleted successfully": "Entradas eliminadas correctamente",
          "Some entries could not be deleted": "Algunas entradas no pudieron ser eliminadas",
          "Error deleting entries": "Error al eliminar las entradas",
          "entries": "entradas",
          "days": "días",
          "selected days": "días seleccionados",
          "- All clubs -": "- Todos los clubes -",
          "- All users -": "- Todos los usuarios -",
          "Member type": "Tipo de miembro",
          "All types": "Todos los tipos",
          "Filters": "Filtros",
          "Select members": "Seleccionar miembros",
          "Please select at least one member": "Por favor selecciona al menos un miembro",
          "Error adding members": "Error al añadir miembros",
          "All teams": "Todos los equipos",
          "Clubs": "Clubes",
          "Teams": "Equipos",
          "Users": "Usuarios",
          "members": "miembros",
          "Search by name or email": "Buscar por nombre o correo",
          "Select all": "Seleccionar todos",
          "No members found": "No se encontraron miembros",
          "Add members": "Añadir miembros",
          "Current members": "Miembros actuales",
          "Share": "Compartir",
          "Team": "Equipo",
          "Club": "Club",
          "All clubs": "Todos los clubes"
        },
      },
    },
  });

export default i18n;
